import React, { useState } from "react";
import Menu from "@/components/Menu";
import Icon from "@ant-design/icons";
import { ReactComponent as Check } from "./check.svg";
import { ReactComponent as Result } from "./result.svg";
import { ReactComponent as User } from "./user.svg";
import { ReactComponent as Person } from "./person.svg";

import { ReactComponent as image } from "./image.svg";
import { ReactComponent as video } from "./video.svg";
import { ReactComponent as deepfake } from "./deepfake.svg";
import { ReactComponent as LLMcheck } from "./LLMcheck.svg";
import { ReactComponent as adimn } from "./admin.svg";
import { ReactComponent as comprehensive } from "./comprehensive.svg";

import "./style.css";
import { useSelector } from "react-redux";

import { DetectionCodeDict } from "@/types/common";

export const items = [
  {
    title: "内容检测",
    key: "content-check",
    icon: <Icon component={Check} />,
    children: [
      {
        value: DetectionCodeDict[6],
        title: "综合检测",
        url: "/content-check/comprehensive-check",
        key: "content-check-comprehensive-check",
        icon: <Icon component={comprehensive} />,
        access: "composite",
      },
      {
        value: DetectionCodeDict[4],
        title: "图片检测大类",
        url: "/content-check/image-class",
        key: "content-check-image-class",
        access: "image_class", //与路由的access对应
        icon: <Icon component={image} />,
      },
      {
        value: DetectionCodeDict[5],
        title: "图片检测大类",
        url: "/content-check/video-class",
        key: "content-check-video-class",
        access: "video_class", //与路由的access对应
        icon: <Icon component={video} />,
      },
      {
        value: DetectionCodeDict[0],
        title: "Deepfake 检测",
        url: "/content-check/deepfake",
        key: "content-check-deepfake",
        access: "deepfake", //与路由的access对应
        icon: <Icon component={deepfake} />,
      },
      {
        value: DetectionCodeDict[1],
        title: "Diffusion 人脸检测",
        url: "/content-check/diffusion",
        key: "content-check-diffusion",
        access: "diffusion",
      },
      {
        value: DetectionCodeDict[3],
        title: "Diffusion 全画幅检测",
        url: "/content-check/diffusion-full-frame",
        key: "content-check-diffusion-full-frame",
        access: "diffusion_full_frame",
      },
      {
        value: DetectionCodeDict[2],
        title: "LLM 检测",
        url: "/content-check/llm",
        key: "content-check-llm",
        access: "llm",
        icon: <Icon component={LLMcheck} />,
      },
    ],
  },
  {
    title: "检测结果",
    url: "/check-result",
    key: "check-result",
    icon: <Icon component={Result} />,
  },
  {
    title: "用户管理",
    url: "/user-management",
    key: "user-management",
    icon: <Icon component={User} />,
    access: "admin",
  },
  {
    title: "配置管理",
    key: "config",
    icon: <Icon component={Person} />,
    children: [
      {
        title: "特定人配置",
        url: "/config/person",
        key: "config-person",
        access: "admin",
        icon: <Icon component={adimn} />,
      },
    ],
  },
];

function changeMenuName(menuList, targetmap) {
  return menuList.map((item) => {
    if (item.children) {
      return {
        ...item,
        children: changeMenuName(item.children, targetmap),
      };
    } else {
      if (item.hasOwnProperty("value") && !!targetmap[item.value]) {
        item.title = targetmap[item.value].label;
        return item;
      }
      return item;
    }
  });
}

const Sider = (props) => {
  const { menuItems, configsDisplay } = useSelector((state) => state.auth);
  const { themeStatus } = useSelector((state: any) => state.contentCheck);
  let newMenuItems = [...menuItems];
  if (configsDisplay) {
    // 修改菜单名字
    newMenuItems = changeMenuName(newMenuItems, configsDisplay.menu_name);
  }
  return (
    <div className={`sider-wrap ${themeStatus == "sun" ? "" : "dark"}`}>
      <Menu defaultSelectedKeys={[props.menuUrl]} items={newMenuItems || []} />
    </div>
  );
};

export default Sider;
